import TrueWallet from './TrueWallet'

export default TrueWallet
